<template>
    <div class="chat-bubble" :class="[
        bubblePosition
    ]">
        <transition name="transition-show-chat-content">
            <div v-if="isChatContentShown" class="chat-popup-content" :style="{
                'margin': `${positionMargin}px`,
                'bottom': `${chatBubbleWidthHeight + positionMargin}px`,
                'width': `${chatContentWidthComputed}px`,
                'height': `${chatContentHeightComputed}px`
            }"
            v-click-outside="handleChatClickOutside">
            </div>
        </transition>

        <a href="javascript:void(0);" @click="isChatContentShown = !isChatContentShown" class="chat-bubble-icon" :style="{
            'width': `${chatBubbleWidthHeight}px`,
            'height': `${chatBubbleWidthHeight}px`,
            'margin': `${positionMargin}px`
        }">
            <i v-show="!isChatContentShown" class="fas fa-comments"></i>
            <i v-show="isChatContentShown" class="fas fa-times"></i>

        </a>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
export default {
    'directives': {
        ClickOutside
    },
    'props': {
        'position': {
            'type': String,
            'default': 'right'
        },
        'positionMargin': {
            'type': Number,
            'default': 20
        },
        'chatContentWidth': {
            'type': Number,
            'default': 350
        },
        'chatContentHeight': {
            'type': Number,
            'default': 550
        }
    },
    data () {
        return {
            'chatBubbleWidthHeight': 60,
            'isChatContentShown': false
            // 'isActivated': false
        };
    },
    'computed': {
        bubblePosition () {
            if (this.position === 'left') {
                return 'bubble-position-left';
            }
            return 'bubble-position-right';
        },
        chatContentWidthComputed () {
            return this.chatContentWidth;
        },
        chatContentHeightComputed () {
            return this.chatContentHeight;
        }
    },
    'methods': {
        handleChatClickOutside () {
            let chatToggleButton = document.querySelector('.chat-bubble-icon');
            let chatToggleNodes = [];
            chatToggleNodes.push(chatToggleButton);

            chatToggleButton.childNodes.forEach((node) => {
                chatToggleNodes.push(node);
            });

            if (!(chatToggleNodes.some((dom) => dom === event.target)) && this.isChatContentShown) {
                this.dismissChatContent();
            }
        },
        dismissChatContent () {
            this.isChatContentShown = false;
        }
    }
};

</script>

<style>
    .chat-bubble .chat-bubble-icon{
        bottom: 0
    }

    .chat-bubble.bubble-position-left .chat-bubble-icon{
        left: 0;
    }

    .chat-bubble.bubble-position-right .chat-bubble-icon{
        right: 0;
    }

    .chat-bubble .chat-bubble-icon {
        position: fixed;
        z-index: 100;
        border-radius: 50%;
        background: #009344;
        box-shadow: rgba(0, 0, 0, .25) 0 0 1em;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;
        font-size: 24px;
        text-decoration: none;
    }

    .chat-bubble .chat-bubble-icon:hover,
    .chat-bubble .chat-bubble-icon:active {
        background: #017b3a;
        box-shadow: rgba(0, 0, 0, .45) 0 0 1em;
    }

    .chat-bubble .chat-popup-content {
        z-index: 99;
        position: fixed;
        box-shadow: rgba(0, 0, 0, .25) 0 0 1em;
        background-color: #fff;
        border-radius: 5px;
    }

    .chat-bubble.bubble-position-left .chat-popup-content {
        left: 0;
    }

    .chat-bubble.bubble-position-right .chat-popup-content {
        right: 0;
    }

    .transition-show-chat-content-enter-active {
        animation: chat-scale-in .3s;
    }

    .transition-show-chat-content-leave-active {
        animation: chat-scale-in .3s reverse;
    }

    @keyframes chat-scale-in {
        0% {
            transform: scale(.8) translate(0, 110px);
            opacity: 0;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }
</style>
